import React from "react";
import SingleEventPage from "../../components/single-event-page/SingleEventPage";
import SeminarImg from "../../assets/event-images/seminar.jpg";

const seminar = {
  image: SeminarImg,
  description:
    "Sakthi Vignesh, Software Team Lead for the Semiconductor Division at Kawasaki Robotics India, is set to deliver a seminar on Deep Learning. With his expertise in robotics and AI, he will explore cutting-edge advancements and practical applications of deep learning in modern technology.",
  type: "Technical Event",
  eventName: "Seminar",
  dateTime: "Mar 01, 10:30AM - 11:30AM",
  venue: "IT-443",
  rules:[
      "Sakthi Vignesh, Software Team Lead for the Semiconductor Division at Kawasaki Robotics India, is set to deliver a seminar on Deep Learning.",
      "Register at just 149",
      "Certifices will be provided(Soft Copy)."
  ],
  contact: [

    {
      name: "Sugithan",
      phoneNo: "8438732387",
    },
    {
      name: "Vishnu Aravind",
      phoneNo: "9003814322",
    },
  ],
};

const Seminar = () => {
  return (
    <SingleEventPage eventDetails={seminar} noPrize={true} isDetails={true} formsLink={"https://docs.google.com/forms/d/e/1FAIpQLSeyv6aHErj-l0HtO8wEXIQSvPe71ajdyHLnRA87ult0CQrgCw/viewform?usp=dialog"} />
  );
};

export default Seminar;
